import { ALL_QUOTES, FILTER_QUOTES, SEARCH_QUOTES, CLEAR_FILTER_QUOTES, ALERT_SESSION } from "../action-types";
import axios from "axios"
import {url, urlFront} from "../../App.js";


export const getAllQuotes = () => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/quotes/`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            dispatch({
                type: ALL_QUOTES,
                payload: response.data
            })
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const getFilterQuotes = (filtros) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'post',
                url: `${url}/quotes/filter`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                data: filtros
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: FILTER_QUOTES,
                    payload: response.data.quotes
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: FILTER_QUOTES,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const getSearchQuotes = (partialId) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/quotes/search/${partialId}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: SEARCH_QUOTES,
                    payload: response.data.quotes
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: SEARCH_QUOTES,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}

export const clearFilterQuotes = () => {
    return {
      type: CLEAR_FILTER_QUOTES,
    };
  };